import React, { useMemo } from 'react';
import { browserDetect, getMobileOperatingSystem } from '../../services/utils';
import { NOT_SUPPORTED_WALLETS_LINKS, WALLET_KEYS_TO_NAME } from '../../constants/wallet';
import { getWalletIcon } from '../../services/providerService';
import Suggestions from './Suggestions';
import './styles.scss';

let wallets = [...Object.keys(NOT_SUPPORTED_WALLETS_LINKS.browser), ...Object.keys(NOT_SUPPORTED_WALLETS_LINKS.mobile)];
wallets = [...new Set(wallets)];

const NotSupported = () => {
  const [mobileSystem, mobileDetected] = useMemo(() => {
    const mobileSystemLoc = getMobileOperatingSystem();
    return [mobileSystemLoc, mobileSystemLoc !== 'unknown'];
  }, []);

  const browserName = useMemo(browserDetect, []);

  return (
    <div className="web3-wc_connect-no-wallets">
      {mobileDetected ? (
        <div className="web3-wc_suggestions-container mobile">
          <div className="web3-wc_title">
            <div className="web3-wc_title-item">
              Please use one of the supported {mobileSystem} wallets and try again
            </div>
          </div>

          <Suggestions browserName={mobileSystem} mobile />
        </div>
      ) : (
        <>
          <div className="web3-wc_suggestions-container">
            {!browserName ? (
              <>
                <div className="web3-wc_title">
                  <div className="web3-wc_title-item">
                    Please install one of the wallet apps or browser extensions with their browser from the list bellow and try again
                  </div>
                </div>

                <div className="web3-wc_suggestions-wrapper">
                  {
                    wallets.map((wallet) => {
                      const walletLabel = useMemo(() => WALLET_KEYS_TO_NAME[wallet], [wallet]);
                      const Icon = useMemo(() => getWalletIcon(walletLabel), [walletLabel]);

                      return (
                        <div key={wallet} className="web3-wc_nowallet-wrapper">
                          <div className="web3-wc_icon-name-wrapper">
                            <Icon />
                            <div className="web3-wc_name">{walletLabel}</div>
                          </div>

                          <ul className="web3-wc_options-wrapper">
                            {
                              ['Chrome', 'Firefox', 'Brave', 'Edge'].map((browser) => {
                                const walletBrowserData = NOT_SUPPORTED_WALLETS_LINKS.browser[wallet]
                                    && NOT_SUPPORTED_WALLETS_LINKS.browser[wallet][browser];

                                if (!walletBrowserData) return null;

                                return (
                                  <li className="web3-wc_option" key={`${wallet}-${browser}`}>
                                    <a
                                      className="web3-wc_option-link"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      href={walletBrowserData}
                                    >
                                      ({browser}) {walletBrowserData}
                                    </a>
                                  </li>
                                );
                              })
                            }

                            {
                              ['Android', 'iOS'].map((osName) => {
                                const walletAppData = NOT_SUPPORTED_WALLETS_LINKS.mobile[wallet]
                                    && NOT_SUPPORTED_WALLETS_LINKS.mobile[wallet][osName];

                                if (!walletAppData) return null;

                                return (
                                  <li className="web3-wc_option" key={`${wallet}-${osName}`}>
                                    <a
                                      className="web3-wc_option-link"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      href={walletAppData}
                                    >
                                      ({osName}) {walletAppData}
                                    </a>
                                  </li>
                                );
                              })
                            }
                          </ul>
                        </div>
                      );
                    })
                  }
                </div>
              </>
            ) : (
              <>
                <div className="web3-wc_title">
                  <div className="web3-wc_title-item">
                    Please install one of the supported {browserName} extensions and try again
                  </div>
                </div>

                <Suggestions browserName={browserName} />
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default NotSupported;
